import type { Moment } from 'moment';
import { useSelector } from 'react-redux';

import { getModifiedBooking } from '@wecasa/booking-modification/src/ducks/basket-selectors';

import { getCreatedAtDeprecated } from '@wecasa/common/src/utils/booking';
import { FORMATS, formatDateDeprecated } from '@wecasa/common/src/utils/date';

import { getBasketMode } from '../ducks/basket';

const formatDateForAPI = (date: Moment) => formatDateDeprecated(date, FORMATS.DATETIME.TIMESTAMPS);

export const useVersionedAt = () => {
  const mode = useSelector(getBasketMode);
  const modificationBooking = useSelector(getModifiedBooking);

  return mode === 'modification' && modificationBooking
    ? formatDateForAPI(getCreatedAtDeprecated(modificationBooking))
    : undefined;
};
